<div class="form-group">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <mat-form-field class="select-wrapper"
                  [class.select-with-icon]="hasIcon"
                  [class.icon-left]="iconPosition === 'left'"
                  [class.icon-right]="iconPosition === 'right'"
                  [class.has-error]="hasError">
    <!-- Icon slot (left) -->
    <div *ngIf="hasIcon && iconPosition === 'left'" class="select-icon select-icon-left" matPrefix>
      <ng-content select="[slot=icon-left]"></ng-content>
    </div>

    <mat-select
      [id]="id"
      [name]="name"
      [required]="required"
      [disabled]="disabled || readonly"
      [(ngModel)]="value"
      (selectionChange)="onSelectChange($event)"
      (blur)="onSelectBlur($event)"
      (focus)="onSelectFocus($event)"
      [placeholder]="placeholder"
      class="form-control">

      <mat-option *ngFor="let option of options" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>

    <!-- Custom dropdown arrow -->
    <span matSuffix class="select-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M6 8.5L2 4.5H10L6 8.5Z" fill="currentColor"/>
      </svg>
    </span>

    <!-- Icon slot (right) -->
    <div *ngIf="hasIcon && iconPosition === 'right'" class="select-icon select-icon-right" matSuffix>
      <ng-content select="[slot=icon-right]"></ng-content>
    </div>
  </mat-form-field>

  <div *ngIf="hasError" class="error-message">
    {{ errorMsg }}
  </div>
</div>
